import axios from 'axios'
import { get } from '@bigyouth/base'
import { Cart } from '../utils/cart'
import { Price } from '../utils/price'
import { Converter } from '../utils/converter'

export default {
  name: 'cart',

  optionsChange: {
    endpoint: '/cart/change.js',
    method: 'POST',
  },

  ui: {
    'buttons[]': '[js-cart-update]',
    'removeButtons[]': '[js-cart-remove]',
    'orderButton': '[js-cart-order]',
  },

  events: [
    {
      on: 'click',
      target: 'buttons',
      handle (e) {
        e.preventDefault()

        const button = e.currentTarget
        let baseQuantity = parseInt(button.parentNode.querySelector('.cart__quantity-number').innerText)
        let quantity = (button.getAttribute('data-change') === 'down') ? baseQuantity - 1 : baseQuantity + 1

        // hide old stock movement
        button.parentNode.querySelectorAll('.cart__quantity-action').forEach(el => {
          el.classList.add('hidden')
        })

        if (quantity > 0) {
          axios({
            url: this.optionsChange.endpoint,
            method: this.optionsChange.method,
            data: {
              id: `${button.getAttribute('data-product-id')}`,
              quantity: quantity,
            },
          })
            .then(res => {
              this.rewriteProductLine(button, baseQuantity, res.data)
            })
            .catch(this.onError.bind(this))
        }

        if (quantity === 1 && button.getAttribute('data-change') === 'down') {
          button.classList.add('hidden')
          button.nextElementSibling.classList.remove('hidden')
        }

        if (quantity === 2 && button.getAttribute('data-change') === 'up') {
          button.parentNode.querySelectorAll('button').forEach(el => {
            el.classList.toggle('hidden')
          })
          button.classList.remove('hidden')
        }
      },
    },
    {
      on: 'click',
      target: 'removeButtons',
      handle (e) {
        e.preventDefault()

        const button = e.currentTarget

        axios({
          url: this.optionsChange.endpoint,
          method: this.optionsChange.method,
          data: {
            id: `${button.getAttribute('data-product-id')}`,
            quantity: 0,
          },
        })
          .then(() => {
            window.location.href = '/cart'
          })
          .catch(this.onError.bind(this))
      },
    },
  ],

  rewriteProductLine (button, baseQuantity, result) {
    let newQuantity = 0
    let linePrice = 0
    const productId = parseInt(button.getAttribute('data-product-id'))

    for (let i in result.items) {
      const item = result.items[i]
      if (item.id === productId) {
        newQuantity = item.quantity
        linePrice = item.line_price
      }
    }

    if (newQuantity === 0) {
      setTimeout(function () {
        window.location.href = '/cart'
      }, 500)
    }

    const quantityBlock = button.parentNode
    const way = button.getAttribute('data-change')

    if (baseQuantity !== newQuantity) {
      quantityBlock.querySelector('.quantity-' + way).classList.remove('hidden')
      quantityBlock.querySelector('.cart__quantity-number').innerHTML = newQuantity

      // reload bottom right total price
      this.rewriteLineTotalPrice(linePrice, productId)

      // reload bottom right total price
      this.rewriteTotalPrice(result.total_price)

      // reload mini cart on top right
      Cart.reloadMiniCart()
    } else {
      // limited stock
      quantityBlock.querySelector('.limited-stock').classList.remove('hidden')

      if (baseQuantity === 1 && button.getAttribute('data-change') === 'up') {
        button.parentNode.querySelectorAll('button').forEach(el => {
          el.classList.toggle('hidden')
        })
        button.classList.remove('hidden')
      }

      setTimeout(function () {
        quantityBlock.querySelector('.limited-stock').classList.add('hidden')
      }, 1500)
    }
  },

  onError () {
    /** @todo handle error **/
  },

  rewriteTotalPrice (price) {
    const totalPrice = get('[js-cart-total-price]')
    const priceWithVAT = Price.addVAT(price)

    totalPrice.innerHTML = parseInt(priceWithVAT)

    Converter.convert(get('[js-converter-select]'), get('[js-converter-currency-total]'), get('[js-converter-currency-symbol]'), priceWithVAT)
  },

  rewriteLineTotalPrice (price, productId) {
    const line = get('[js-cart-line-' + productId + ']')
    let totalLine = line.querySelector('.line-price')
    totalLine.innerHTML = parseInt(Price.addVAT(price))
  },

}
